module.exports = __webpack_public_path__ + "static/media/Жумабаев А.be48ea2e.pdf";